import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as SCHEMEACTIONS } from "../../../store/actions/schemeActions";
import { format } from "date-fns";
import { ClipboardIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/tooltip";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const SchemesRow = ({ scheme, schemeTypeOptions, isAdmin, setOpenSchemeModal, deleteSchemeModal, permissions }) => {
	return (
		<tr key={scheme.id + "-"}>
			<td width="5%">
				{permissions && (
					<div
						className="btn btn-xs btn-default"
						style={{ marginLeft: 10, marginRight: 10 }}
						onClick={() => {
							setOpenSchemeModal(scheme);
						}}
					>
						<Tooltip content="Edit Scheme">
							<PencilSquareIcon
								className="h-5 w-5 text-dark-gray"
								style={{ marginTop: "3px" }}
							/>
						</Tooltip>
					</div>
				)}
				{isAdmin && (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(scheme.id)}
						style={{ marginRight: 10 }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}
			</td>
			<td>{scheme.name}</td>
			<td>{schemeTypeOptions?.find((schemeType) => schemeType?.value == scheme?.schemeType)?.label}</td>
			<td>{scheme.provider || "Other"}</td>
			<td>
				{scheme.startDate && format(new Date(scheme.startDate), "do MMM yyyy")} -{" "}
				{scheme.endDate && scheme.endDate != "null" ? format(new Date(scheme.endDate), "do MMM yyyy") : "Now"}
			</td>
			{/* <td>{}</td> */}
			<td>
				{permissions && (
					<div
						className="btn btn-xs btn-danger"
						style={{ marginLeft: 10, marginRight: 10 }}
						onClick={() => {
							deleteSchemeModal(scheme);
						}}
					>
						<Tooltip content="Delete Scheme">
							<TrashIcon
								className="h-5 w-5"
								style={{ marginTop: "3px" }}
							/>
						</Tooltip>
					</div>
				)}
			</td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { scheme } = ownProps;

	const schemeTypeOptions = [
		{ value: "banded", label: "Banded" },
		{ value: "unbanded", label: "Unbanded" },
		{ value: "type1", label: "Type 1" },
		{ value: "type2", label: "Type 2" },
		{ value: "type3", label: "Type 3" },
	];

	return {
		scheme,
		schemeTypeOptions,
		isAdmin: state?.my?.profile?.isAdmin,
		permissions: state?.permissions?.my?.permissions?.pensions != "Read",
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenSchemeModal: (scheme) => dispatch(SCHEMEACTIONS.setOpenSchemeModal(true, scheme)),
	deleteSchemeModal: (scheme) => dispatch(SCHEMEACTIONS.deleteSchemeModal(true, scheme)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchemesRow);
